module.exports = __webpack_public_path__ + "static/media/chris.2132d5d8.png";